@if (createOrUpdateDrawerIsOpen && !!updatedEmailId) {
  <app-email-create-or-update
    [mailAccountId]="mailAccountId"
    [emailId]="updatedEmailId"
    [inlineImagesSourceEmailId]="emailId"
    [useMobileView]="useMobileView"
    (submitted)="closeEmailModalForm()">
  </app-email-create-or-update>
}

@if (emailDrawerIsOpen && !!openedEmail && !!openedEmail.emailId) {
  <app-email-detail-dialog
    [emailId]="openedEmail.emailId"
    (closeDrawer)="closeEmailModalForm()"
    [notesCount]="openedEmail.notesCount"
    [useMobileView]="useMobileView">
  </app-email-detail-dialog>
}

@if (cannotLoadEmailDetails) {
  <div class="h-full w-full">
    <app-something-went-wrong
      [showPicture]="false"
      (retryEmitter)="ngOnInit()"></app-something-went-wrong>
  </div>
}

@if (isLoading) {
  <app-skeleton-email></app-skeleton-email>
}

@if (!createOrUpdateDrawerIsOpen && !emailDrawerIsOpen) {
  <div
    (click)="checkingTheActiveElement()"
    class="flex h-full justify-between overflow-y-auto overflow-x-clip">
    @if (!isLoading && !cannotLoadEmailDetails) {
      <div class="flex h-full w-full flex-col overflow-x-clip">
        <div class="relative flex">
          <span class="custom-top absolute">{{ 'from' | translate }}</span>
          <span class="subject">{{ emailDetails.from }}</span>
        </div>
        <div class="relative flex">
          <span class="custom-top absolute">{{ 'to' | translate }}</span>
          <span class="subject subject_break-all">{{
            emailDetails.to | formatSemicolon
          }}</span>
        </div>
        @if (!!emailDetails?.cc) {
          <div class="relative flex">
            <span class="custom-top absolute">{{ 'cc' | translate }}</span>
            <span class="subject subject_break-all">{{
              emailDetails.cc | formatSemicolon
            }}</span>
          </div>
        }
        @if (emailDetails.subject) {
          <div class="relative flex">
            <span class="custom-top absolute">{{ 'subject' | translate }}</span>
            <span class="subject subject_break-all">{{
              emailDetails.subject
            }}</span>
          </div>
        }
        <div class="relative flex">
          <span class="custom-top absolute">{{ 'date' | translate }}</span>
          <span class="subject">{{
            getDate(emailDetails) | date: 'dd/MM/yyyy HH:mm:ss'
          }}</span>
        </div>

        <app-field-tags-list
          [thisTags]="thisTags"
          (openAddTag)="openAddTag()" />

        <div class="min-h-[200px] flex-grow">
          <div class="drawer-content-screen__body relative mt-[2px]">
            <div class="absolute right-0 top-0 z-10">
              <button
                mat-icon-button
                aria-label="Menu"
                [matMenuTriggerFor]="menu"
                matTooltip="{{ 'menu' | translate }}">
                <mat-icon>more_vert</mat-icon>
              </button>
            </div>
            <app-email-body
              [disabled]="true"
              [body]="body"
              class="h-full"></app-email-body>
          </div>
        </div>

        @if (haveAttachments) {
          <app-email-attachments-list
            [attachmentFiles]="visibleAttachmentFiles"
            [emailId]="emailId"
            [isDetails]="true" />
        }

        <div
          style="overflow: initial"
          class="icon-button-group mr-2 flex h-[80px] items-center justify-between overflow-hidden">
          <div class="icon-button-group mr-2 flex items-center">
            <app-reply-button
              [showButton]="
                !isReplying && showIcon(typeFour) && emailDetails?.state !== 7
              "
              [showLoading]="isReplying"
              [disabled]="isForwarding || isForwardingAttachment || isReplyingAll"
              (click)="reply()" />
            <app-reply-all-button
              [showButton]="
                !isReplyingAll &&
                showIcon(typeFour) &&
                emailDetails?.state !== 7
              "
              [showLoading]="isReplyingAll"
              [disabled]="isReplying || isForwarding || isForwardingAttachment"
              (click)="replyAll()" />
            <app-forward-button
              [showButton]="
                !isForwarding && showIcon(typeFour) && emailDetails?.state !== 7
              "
              [showLoading]="isForwarding"
              [disabled]="isReplying || isReplyingAll || isForwardingAttachment"
              (click)="forward()" />
            <app-forward-attachment-button
              [showButton]="
                !isForwardingAttachment &&
                showIcon(typeFour) &&
                emailDetails?.state !== 7
              "
              [showLoading]="isForwardingAttachment"
              [disabled]="isReplying || isReplyingAll || isForwarding"
              (click)="forwardAsAttachment()" />

            @if (canValidate && emailDetails?.state === 7) {
              <div>
                <div class="button-group">
                  @if (canValidate && emailDetails?.state === 7) {
                    <button
                      color="primary"
                      class="page-block-button"
                      mat-flat-button
                      aria-label="Approve"
                      (click)="approve()"
                      [disabled]="approveInProgress || rejectInProgress"
                      matTooltip="{{ 'approve' | translate }}">
                      @if (!approveInProgress) {
                        <mat-icon class="mb-[3px]">check</mat-icon>
                      }
                      <app-loading-button
                        text="{{ 'approveAndSend' | translate }}"
                        [loading]="approveInProgress"></app-loading-button>
                    </button>
                  }
                  @if (canValidate && emailDetails?.state === 7) {
                    <button
                      color="primary"
                      class="page-block-button"
                      mat-flat-button
                      aria-label="Reject"
                      (click)="reject()"
                      [disabled]="approveInProgress || rejectInProgress"
                      matTooltip="{{ 'reject' | translate }}">
                      @if (!rejectInProgress) {
                        <mat-icon class="mb-[3px]">clear</mat-icon>
                      }
                      <app-loading-button
                        text="{{ 'rejectApproval' | translate }}"
                        [loading]="rejectInProgress"></app-loading-button>
                    </button>
                  }
                </div>
              </div>
            }
          </div>
          <div class="flex items-center">
            <app-validate-button
              [showButton]="
                showIcon([mailFolderType.Inbox]) &&
                (emailDetails.validationState ===
                  emailValidationState.NotValidated ||
                  emailDetails.validationState === emailValidationState.New) &&
                !validatingEmail
              "
              [showLoading]="validatingEmail"
              (click)="setValidated()" />

            <button
              mat-icon-button
              aria-label="Print"
              (click)="print()"
              matTooltip="{{ 'print' | translate }}">
              <span class="material-symbols-outlined">print</span>
            </button>

            <app-notes-button (click)="showNotes()" [hasCount]="!!notesCount" />

            @if (showIcon(typeTwo)) {
              <button
                mat-icon-button
                aria-label="Open notifications"
                (click)="showNotifications()"
                matTooltip="{{ 'openNotifications' | translate }}">
                <mat-icon>notifications_outline</mat-icon>
              </button>
            }
          </div>
        </div>
      </div>
      <mat-menu #menu="matMenu">
        <app-download-single-eml-button
          [isMenu]="true"
          [showButton]="showIcon(typeOne)"
          [showLoading]="false"
          (click)="downloadSingleEML()" />

        <app-download-eml-button
          [isMenu]="true"
          [showButton]="showIcon(typeOne)"
          [showLoading]="false"
          (click)="downloadEML()" />

        <app-audit-button [isMenu]="true" (click)="audit()" />

        @if (showIcon([mailFolderType.Inbox]) && !emailDetails.isSpam) {
          <app-mark-as-span-button [isMenu]="true" (click)="isSpam()" />
        }

        @if (showIcon([mailFolderType.Spam]) && emailDetails.isSpam) {
          <app-mark-as-not-span-button
            [isMenu]="true"
            (click)="restoreMoveFolderChoose([emailId], 'restoreOneSpam')" />
        }

        @if (showIcon(typeOne) && emailDetails.seen) {
          <app-set-unread-button [isMenu]="true" (click)="setSeen(false)" />
        }

        @if (showIcon(typeOne) && !emailDetails.seen) {
          <app-set-read-button [isMenu]="true" (click)="setSeen(true)" />
        }

        @if (canValidate && emailDetails?.state === 7) {
          <button mat-menu-item (click)="approve()" [disableRipple]="true">
            <mat-icon>check</mat-icon>{{ 'approve' | translate }}
          </button>
        }

        @if (canValidate && emailDetails?.state === 7) {
          <button mat-menu-item (click)="approve()" [disableRipple]="true">
            <mat-icon>clear</mat-icon>{{ 'reject' | translate }}
          </button>
        }

        @if (
          (showIcon(typeThree) ||
            emailDetails?.state === emailStates.VirusDetected) &&
          !emailDetails.deleted
        ) {
          <app-delete-button [isMenu]="true" (click)="delete()" />
        }

        @if (showIcon([mailFolderType.Trash]) && emailDetails.deleted) {
          <app-restore-button [isMenu]="true" (click)="restoreFromTrash()" />
        }
      </mat-menu>
    }
    <app-email-sidenav
      [menuContent]="menuContent"
      [useMobileView]="useMobileView"
      [emailId]="emailId"
      [mailAccountId]="mailAccountId"
      [menuIsOpened]="menuIsOpened"
      [emailDetails]="emailDetails"
      (closeMenu)="closeMenu()"
      (openEmailDetails)="openEmailDetails($event)"
      (createTag)="createTag($event)"
      (refreshNotes)="
        refreshNotes.emit($event); notesCount = notesCount + 1
      "></app-email-sidenav>
  </div>
}
